import { useAuth } from "../../../../context/AuthContext";
import EditProject from "../project-crud/EditProject";
import EditAmsProject from "../../../amsProject/pages/project-crud/EditAmsProject";

export default function ProjectEditRouter() {
    const { activeDepartment } = useAuth();

    if (activeDepartment === 'AMS') {
        return <EditAmsProject />;
    }

    return <EditProject />;
}
